import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { selectAIMessages } from '@store/reducers/ai'
import { selectConvertedProject } from '@store/reducers/ai/selectors'
import type { AiRequest } from '@store/reducers/ai/types'
import { prepareMessagesForRequest } from '@store/reducers/ai/utils/prepareMessages'
import type { SagaIterator } from 'redux-saga'
import { select } from 'redux-saga/effects'

export function* prepareAIRequestData(): SagaIterator<AiRequest> {
  const project = yield select(selectConvertedProject)
  const projectId = yield select(migrationProjectSelector.getProjectId)
  const currentTabId = yield select(
    migrationProjectSelector.getActiveOrFirstTabId
  )
  const contextMessages = yield select(selectAIMessages)

  return {
    messages: prepareMessagesForRequest(contextMessages),
    project,
    projectId,
    currentTabId,
  }
}
